
import { useRef, useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";


interface CashReportSearchProps {
  onSearch: (payload: any) => void;
  setLoading: (loading: boolean) => void;
  onReset: () => void;
  totalCurrentlyHolding: number; 
  AccountsReceivedcash: number;
}

const CashReportSearch: React.FC<CashReportSearchProps> = ({ onSearch, setLoading,onReset,totalCurrentlyHolding,AccountsReceivedcash }) => {
  const toast = useRef<Toast>(null);

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  
  const formatToSQLDateTime = (date: Date) =>
    date.toLocaleString("sv-SE").replace(" ", "T");

  const handleSearch = () => {
    if (!startDate || !endDate) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation",
        detail: "Please select both Start Date and End Date."
      });
      return;
    }
debugger
    const payload = {
      startDate: formatToSQLDateTime(new Date(startDate.setHours(0, 0, 0, 0))),
      endDate: formatToSQLDateTime(new Date(endDate.setHours(23, 59, 59, 999)))

    };
debugger
    onSearch(payload);
  };

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    onReset();
  };

  const balance = totalCurrentlyHolding - AccountsReceivedcash;

  return (
    <div className="card border-noround p-3 w-full">
      <Toast ref={toast} />

      <div className="grid">
       
        <div className="col-6 md:col-2">
          <Calendar
            value={startDate}
            onChange={(e) => setStartDate(e.value as Date)}
            showButtonBar
            dateFormat="dd/mm/yy"
            placeholder="Start Date"
            className="w-full"
            readOnlyInput
          />
        </div>

        <div className="col-6 md:col-2">
          <Calendar
            value={endDate}
            onChange={(e) => setEndDate(e.value as Date)}
            showButtonBar
            dateFormat="dd/mm/yy"
            placeholder="End Date"
            className="w-full"
            readOnlyInput
          />
        </div>

        <div className="col-6 md:col-1">
          <Button label="Filter" onClick={handleSearch} severity="success" className="w-full" />
        </div>

        <div className="col-6 md:col-1">
          <Button label="Reset" onClick={handleReset} severity="secondary" className="w-full" text raised />
        </div>
 <div className="col-6 md:col-2" /> 

 {(totalCurrentlyHolding > 0 || AccountsReceivedcash > 0) && (
       <div className="col-12 md:col-4 flex flex-column align-items-end justify-content-center gap-1">
        <div className="text-right font-bold text-md">
          Total Cash Holding: ₹{totalCurrentlyHolding.toFixed(2)}

            <div className="text-right font-semibold text-md text-green-700">
              Deposited to Bank yet to verify: ₹{AccountsReceivedcash.toFixed(2)}
            </div>
            <div className="text-right font-semibold text-md text-orange-700">
              Net cash available: ₹{balance.toFixed(2)}
            </div>
        </div>
      </div>
      )}
    </div>

     
    </div>
  );
};

export default CashReportSearch;
